
export default {
  area: "汝宁街道数智管理平台",
  objectName: "",
  //线上地址
  hostUrl: 'https://rnxrnjd.anluoyun.cn',
  apiHttpsUrl: 'https://rnxrnjd.anluoyun.cn/prod-api/',
  apiRequestUrl: 'https://rnxrnjd.anluoyun.cn/prod-api',
  apiUploadUrl: 'https://rnxrnjd.anluoyun.cn/prod-api/common/OssUploadImg',
  apiUploadFiles: 'https://rnxrnjd.anluoyun.cn/prod-api/common/OssUploadImg',
  apiUploadvideo: 'https://rnxrnjd.anluoyun.cn/prod-api/UploadFile/UploadQiniuVideo', 
  // 本地地址
  // hostUrl: 'https://rnxrnjd.anluoyun.cn',
  // apiHttpsUrl: 'http://192.168.1.18:8091',
  // apiRequestUrl: 'http://192.168.1.18:8091',
  // apiUploadUrl: 'https://rnxrnjd.anluoyun.cn/prod-api/common/OssUploadImg',
  // apiUploadFiles: 'https://rnxrnjd.anluoyun.cn/prod-api/common/OssUploadImg',
  // apiUploadvideo: 'https://rnxrnjd.anluoyun.cn/prod-api/UploadFile/UploadQiniuVideo',

  // 积分商城平台标识
  platformId: 'hy_zhsq',
}